module.exports = __webpack_public_path__ + "static/media/10 Minutes of Meeting 4th RAC 2023.ab941df3.pdf";